var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23409",
    "data-name": "Rectangle 23409",
    width: 40,
    height: 40,
    transform: "translate(14410 -2723)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project",
    transform: "translate(-14410 2723)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "project-2",
    "data-name": "project",
    transform: "translate(14404.114 -2722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73199",
    "data-name": "Path 73199",
    d: "M39.21,1.44V32.495s-27,5.465-28.5,5.5h-.075a2.753,2.753,0,0,1-2.752-2.752V1.44A1.44,1.44,0,0,1,9.326,0H37.771a1.44,1.44,0,0,1,1.44,1.44Z",
    fill: "#faf7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73200",
    "data-name": "Path 73200",
    d: "M39.21,427.118v.795s-27,5.465-28.5,5.5h-.075a2.753,2.753,0,0,1-2.752-2.752v-3.547H39.21Z",
    transform: "translate(0 -395.418)",
    fill: "#dedbee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66857",
    "data-name": "Group 66857",
    transform: "translate(27.947 18.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73201",
    "data-name": "Path 73201",
    d: "M291.767,252.313l-.978-.565a5.68,5.68,0,0,0,0-2.424l.978-.565a1.035,1.035,0,0,0,.378-1.414l-.694-1.2a1.035,1.035,0,0,0-1.414-.379l-.979.565a5.679,5.679,0,0,0-2.1-1.213v-1.128a1.035,1.035,0,0,0-1.034-1.034h-1.388a1.035,1.035,0,0,0-1.034,1.034v1.128a5.679,5.679,0,0,0-2.1,1.213l-.978-.565a1.035,1.035,0,0,0-1.414.379l-.694,1.2a1.035,1.035,0,0,0,.378,1.414l.979.565a5.68,5.68,0,0,0,0,2.424l-.979.565a1.035,1.035,0,0,0-.378,1.414l.694,1.2a1.035,1.035,0,0,0,1.414.379l.978-.565a5.679,5.679,0,0,0,2.1,1.213v1.128a1.035,1.035,0,0,0,1.034,1.034h1.388a1.035,1.035,0,0,0,1.034-1.034v-1.128a5.679,5.679,0,0,0,2.1-1.213l.979.565a1.035,1.035,0,0,0,1.414-.379l.694-1.2A1.035,1.035,0,0,0,291.767,252.313Zm-6.536.626a2.4,2.4,0,1,1,2.4-2.4A2.4,2.4,0,0,1,285.231,252.939Z",
    transform: "translate(-278.178 -242.953)",
    fill: "#7a6d79"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73202",
    "data-name": "Path 73202",
    d: "M77.61,437.827a1.44,1.44,0,0,1,1.44,1.44v1.313a2.752,2.752,0,0,1-2.753,2.753H44.973a2.752,2.752,0,0,0,2.752-2.753v-1.313a1.44,1.44,0,0,1,1.44-1.44Z",
    transform: "translate(-34.334 -405.332)",
    fill: "#faf7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66858",
    "data-name": "Group 66858",
    transform: "translate(9.714 2.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73203",
    "data-name": "Path 73203",
    d: "M213.934,38.9a.573.573,0,0,0-.573.573v3.347a.274.274,0,0,1-.136.243c-.148.082-.341-.088-.363-.108a.573.573,0,1,0-.771.849,1.6,1.6,0,0,0,1.047.432,1.313,1.313,0,0,0,.644-.171,1.422,1.422,0,0,0,.726-1.245V39.472A.574.574,0,0,0,213.934,38.9Z",
    transform: "translate(-198.589 -38.899)",
    fill: "#685e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73204",
    "data-name": "Path 73204",
    d: "M260.883,40.562a.573.573,0,1,0,0-1.147h-1.748a.573.573,0,0,0-.573.573v4.149a.573.573,0,0,0,.573.573h1.748a.573.573,0,1,0,0-1.147h-1.175v-.928h1.046a.573.573,0,1,0,0-1.147h-1.046v-.928Z",
    transform: "translate(-241.784 -39.377)",
    fill: "#685e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73205",
    "data-name": "Path 73205",
    d: "M305.434,42.629a.573.573,0,0,0-.808.071,1.075,1.075,0,0,1-.879.386,1.52,1.52,0,1,1,.85-2.781.573.573,0,0,0,.642-.95,2.667,2.667,0,1,0-1.492,4.878,2.22,2.22,0,0,0,1.758-.8A.573.573,0,0,0,305.434,42.629Z",
    transform: "translate(-281.148 -38.899)",
    fill: "#685e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73206",
    "data-name": "Path 73206",
    d: "M369.826,38.9h-2.312a.573.573,0,1,0,0,1.147h.578V43.66a.573.573,0,1,0,1.147,0V40.046h.587a.573.573,0,0,0,0-1.147Z",
    transform: "translate(-342.12 -38.899)",
    fill: "#685e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73207",
    "data-name": "Path 73207",
    d: "M91.219,40.561A1.7,1.7,0,0,0,89.5,38.9H88.383a.573.573,0,0,0-.573.575V43.66a.573.573,0,1,0,1.147,0V42.607l1.26,1.432a.573.573,0,0,0,.861-.758L90.062,42.13A1.67,1.67,0,0,0,91.219,40.561Zm-1.723.515-.535,0c0-.2,0-.826,0-1.031H89.5a.518.518,0,1,1,0,1.03Z",
    transform: "translate(-83.705 -38.899)",
    fill: "#685e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73208",
    "data-name": "Path 73208",
    d: "M34.258,38.9H33.092a.574.574,0,0,0-.573.575V43.66a.573.573,0,0,0,1.147,0V42.411l.592,0a1.755,1.755,0,1,0,0-3.51Zm0,2.363-.588,0c0-.227,0-.98,0-1.218h.591a.609.609,0,1,1,0,1.216Z",
    transform: "translate(-32.519 -38.899)",
    fill: "#685e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73209",
    "data-name": "Path 73209",
    d: "M141.166,38.9a2.667,2.667,0,1,0,2.667,2.667A2.67,2.67,0,0,0,141.166,38.9Zm0,4.187a1.52,1.52,0,1,1,1.52-1.52A1.522,1.522,0,0,1,141.166,43.086Z",
    transform: "translate(-130.633 -38.899)",
    fill: "#685e68"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73210",
    "data-name": "Path 73210",
    d: "M74.357,127.387H50.406a.573.573,0,1,1,0-1.147H74.357a.573.573,0,0,1,0,1.147Z",
    transform: "translate(-38.834 -116.871)",
    fill: "#dedbee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73211",
    "data-name": "Path 73211",
    d: "M54.349,177.3H44.76a1.613,1.613,0,0,1-1.613-1.613v-5.165a1.613,1.613,0,0,1,1.613-1.613h9.589a1.613,1.613,0,0,1,1.613,1.613v5.165A1.613,1.613,0,0,1,54.349,177.3Z",
    transform: "translate(-32.644 -156.373)",
    fill: "#ffd15b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73212",
    "data-name": "Path 73212",
    d: "M254.275,192.134H243.6a.573.573,0,1,1,0-1.147h10.679a.573.573,0,1,1,0,1.147Z",
    transform: "translate(-217.685 -176.812)",
    fill: "#685e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73213",
    "data-name": "Path 73213",
    d: "M250.156,221.938H243.6a.573.573,0,0,1,0-1.147h6.56a.573.573,0,0,1,0,1.147Z",
    transform: "translate(-217.685 -204.404)",
    fill: "#685e68"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66859",
    "data-name": "Group 66859",
    transform: "translate(9.93 22.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73214",
    "data-name": "Path 73214",
    d: "M51.4,310.323H35.994a.573.573,0,1,1,0-1.147H51.4a.573.573,0,1,1,0,1.147Z",
    transform: "translate(-35.421 -309.176)",
    fill: "#7a6d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73215",
    "data-name": "Path 73215",
    d: "M51.4,369.932H35.994a.573.573,0,1,1,0-1.147H51.4a.573.573,0,1,1,0,1.147Z",
    transform: "translate(-35.421 -364.361)",
    fill: "#7a6d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73216",
    "data-name": "Path 73216",
    d: "M43.393,400.59h-7.4a.573.573,0,0,1,0-1.147h7.4a.573.573,0,0,1,0,1.147Z",
    transform: "translate(-35.421 -392.743)",
    fill: "#7a6d79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66860",
    "data-name": "Group 66860",
    transform: "translate(12.466 14.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73217",
    "data-name": "Path 73217",
    d: "M69.6,226.461h3.577v2.288H69.6Z",
    transform: "translate(-69.601 -224.351)",
    fill: "#fe646f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73218",
    "data-name": "Path 73218",
    d: "M141.16,198.027h3.577v4.4H141.16Z",
    transform: "translate(-135.849 -198.027)",
    fill: "#bbec6c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73219",
    "data-name": "Path 73219",
    d: "M52.394,340.127h-16.4a.573.573,0,0,1,0-1.147h16.4a.573.573,0,0,1,0,1.147Z",
    transform: "translate(-25.491 -313.821)",
    fill: "#7a6d79"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/Project.c58783a4f1a7a6b13e24f8f3cb587d75.svg";
export { ForwardRef as ReactComponent };